module.exports = "https://static.wagwalking.com/_next/static/images/dog-bowl-ef8c29f7fadab2491abe6b558fd90838.png";